import { type CaptureOptions, type EventName, type EventProperties, trackEvent } from '@monorepo/common';
import { getDataLayer } from './ga';

/**
 * GA4(dataLayer) と PostHog の両方へ、同名・同パラメータで送る（dual-send / GF-2121）。
 *
 * PostHog導入後も広告運用で GA4 も必要なため、ドメインイベントは両系統に二重送出する。
 *
 * @param options PostHog 側 capture オプション。離脱など確実に送りたいイベントは
 *   `{ send_instantly: true, transport: 'sendBeacon' }` を渡す（GA4 側は gtag/GTM が beacon 送信）。
 */
export function trackDualEvent<E extends EventName>(
  name: E,
  properties: EventProperties[E],
  options?: CaptureOptions,
): void {
  getDataLayer().push({ event: name, ...properties });
  trackEvent(name, properties, options);
}
